// extracted by mini-css-extract-plugin
module.exports = {"separator":"separator-component_separator__3l2TC","mask":"separator-component_mask__1j50C"};